import React from 'react';
import { Route } from 'react-router-dom';
import { createRoute } from '@core/router';
import iotDashboardRoute from '@modules/iot/dashboard/DashboardPage';

const dashBoardRoutes = <Route index {...createRoute(iotDashboardRoute)} />;

export default dashBoardRoutes;
